import React from 'react';
import PropTypes from 'prop-types';
import './blocks.scss';
// const mockData = [
//     {
//       hasActivited: false,  // 当前的block是否被激化
//       text: 'text',         // 当前的block的文本
//       blockStyles: {},      // 当前的block的样式
//       child:vDOM            // 可传入虚拟DOM
//       borderStyle           // 当前的block的border
//       borderRadius          // 每个block的borderRadius
//     }
// ];
const IndividualBlocks = ({
  data = [], // 组件的数据
  columnNum, // 展示的列数
  blocksBoxStyles = {}, // blocks外层盒子的样式
  blockStyles = {}, // 每个block的样式
  click = () => {}, // 每个block的点击事件
  justifyContent, // 总体的排版布局
  borderStyle, // 每个block的borderStyle
  borderRadius, // 每个block的borderRadius
}) => (
  <div
    className="blocks-box"
    style={{
      justifyContent,
      ...blocksBoxStyles,
    }}
  >
    {Array.isArray(data) &&
      data.map((item = {}, idx) => (
        <div
          className={`block 
                      ${item.hasActivited === true && 'hasActivited'}
                      ${item.borderStyle || borderStyle}
                      ${item.borderRadius || borderRadius}
                    `}
          style={{
            width: `${
              columnNum ? (1 / columnNum) * 100 - (columnNum - 1) : 'auto'
            }%`,
            marginRight: (idx + 1) % columnNum === 0 && '0px',
            backgroundColor: item.backgroundColor,
            ...item.blockStyles,
            ...blockStyles,
          }}
          key={idx + item.text}
          onClick={() => click(item, idx, data)}
        >
          {item.child ? item.child : item.text}
        </div>
      ))}
  </div>
);
IndividualBlocks.propTypes = {
  data: PropTypes.array.isRequired,
  columnNum: PropTypes.number,
  blocksBoxStyles: PropTypes.object,
  blockStyles: PropTypes.object,
  click: PropTypes.func,
};
export default IndividualBlocks;
